<div class="modal-header">
  <h4 class="modal-title pull-left" *ngIf="transactionTypeId == 6500 && !property.IsPortfolio">Sale History</h4>
  <h4 class="modal-title pull-left" *ngIf="transactionTypeId == 6501 && !property.IsPortfolio">Lease History</h4>
  <h4 class="modal-title pull-left" *ngIf="transactionTypeId == 6500 && property.IsPortfolio">Porfolio History</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div style="min-height:100%; " *ngIf="isShowForm">
    <div class="textbox-date margin-bottom-20">
      <div class="cf row">
        <div class="col-md-3">
          <label class="be-label">Event</label>
          <label class="select">
            <select class="form-control " [(ngModel)]="propertyRevisionModel.EventTypeId" (change)="eventChanged()" required>
              <option [value]="null" *ngIf="transactionTypeId != 6500">Select</option>
              <option *ngFor="let item of lookupData" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
          </label>

        </div>
      </div>
    </div>

    <form class="pt-2 row" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <div formArrayName="formFields" class="cf">
        <div [formGroupName]="i" *ngFor="let control of fields().controls; index as i">

          <div [ngSwitch]="true" class="col-md-3" *ngIf="childFields(i).controls.length <=1">
            <div class="form-group textbox-with-btn-left textbox-with-2character col-md-12" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType==='String'">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <input type="text" class="form-control" formControlName="NewValue" placeholder="Enter {{control.value.Name}}">
            </div>
            <div class="form-group" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Decimal' && (control.value.Name != 'Asking Cap Rate' && control.value.Name != 'Sale Cap Rate')">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <input type="text"
                     inputmode="numeric"
                     min="0"
                     mask="separator.2"
                     [dropSpecialCharacters]="false"
                     class="form-control"
                     value="{{control.value.NewValue}}"
                     formControlName="NewValue"
                     placeholder="Enter {{control.value.Name}}"
                     (keyup)="newValueChange(control.value)" thousandSeparator="," />
              <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
              <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
            </div>
            <div class="form-group" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Decimal' && (control.value.Name == 'Asking Cap Rate' || control.value.Name == 'Sale Cap Rate')">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <input type="text" min="0" max="100.00" dropSpecialCharacters="false" class="form-control" value="{{control.value.NewValue|toNumber|number}}" formControlName="NewValue" placeholder="Enter {{control.value.Name}}" (keyup)="newValueChange(control.value)">
              <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
              <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
              <div *ngIf="(capRateValidationText != '' || askingPriceValidationText != '')">
                <p class="redtext error-floating" *ngIf="capRateValidationText != '' && control.value.Name == 'Sale Cap Rate'">
                  {{capRateValidationText}}
                </p>
                <p class="redtext error-floating" *ngIf="askingPriceValidationText != '' && control.value.Name == 'Asking Cap Rate'">
                  {{askingPriceValidationText}}
                </p>
              </div>
            </div>
            <div class="form-group" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Integer'">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <input type="text" min="1" [min]="1" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'false', decimal: '.', precision: '0',inputMode: 'NATURAL', thousands: ',', nullable: 'true' }" class="form-control" formControlName="NewValue" placeholder="Enter {{control.value.Name}}" (keyup)="newValueChange(control.value)" value="{{control.value.NewValue|toNumber|number}}">
              <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
              <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
            </div>
            <div class="form-group" style="margin-top:40px;" *ngSwitchCase="control.value.DataType === 'Boolean'">
              <label class="form-label">

              </label>
              <label class="custom-checkbox margin-right-15" for="{{control.value.Name}}">
                <input readonly="readonly" formControlName="NewValue" type="checkbox" (change)="autoCalcNewValue($event, control.value)" id="{{control.value.Name}}">{{control.value.Name}}
                <i></i>
              </label>
            </div>
            <div class="textbox-date form-group" *ngSwitchCase="control.value.DataType === 'Datetime'">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <input bsDatepicker class="form-control" placeholder="mm/dd/yyyy" (ngModelChange)="onNewDateSelection($event, control.value)" type="text" formControlName="NewValue" placement="auto">

              <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <div class="textbox-date form-group" *ngSwitchCase="control.value.DataType === 'AutoPopulate'">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <div class="form-group autocomplete-design">
                <!--<ng2-completer [textSearching]="TenantName" [maxChars]="90" [datasource]="dataService" class="form-control"
                 formControlName="NewValue" (selected)="onTenantSelect($event)" [overrideSuggested]="true" [minSearchLength]="0" (blur)="onTenantBlur($event)"></ng2-completer>-->
                <ng-select [items]="dataService$ | async"
                           bindValue="TenantName"
                           bindLabel="TenantName"
                           [hideSelected]="true"
                           [loading]="loading"
                            [typeahead]="dataServiceInput$"
                           [minTermLength]="0"
                           formControlName="NewValue"
                           (change)="onTenantSelect($event)">
                </ng-select>
              </div>
            </div>
            <div class="form-group" *ngSwitchCase="control.value.DataType === 'Dropdown'" style="margin-bottom:15px !important">
              <label class="form-label">
                {{control.value.Name}}
              </label>
              <label class="select">
                <select formControlName="NewValue"
                        class="form-control ">
                  <option [value]="null">Select</option>
                  <option *ngFor="let item of control.value.DropDownData.__zone_symbol__value" [(ngValue)]="item.id">{{item.name}}</option>
                </select>
                <i></i>
              </label>

            </div>
            <div formArrayName="ChildItems">
              <div [formGroupName]="p" *ngFor="let it of childFields(i).controls; index as p">
                <div class="form-group" *ngSwitchCase="it.value.DataType === 'Boolean'">
                  <label class="form-label">
                  </label>
                  <label class="custom-checkbox margin-right-15" for="{{it.value.Name}}">
                    <input readonly="readonly" formControlName="NewValue" type="checkbox" (change)="autoCalcNewValue($event, it.value)" id="{{it.value.Name}}"> {{it.value.Name}}
                    <i></i>
                  </label>
                </div>

                <div [ngClass]="{'textbox-with-btn-left':it.value.Prefix,'textbox-with-btn':it.value.Suffix}" class="form-group" *ngSwitchCase="it.value.DataType === 'Integer'">
                  <label class="form-label">
                  </label>
                  <input type="text" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'false', decimal: '.', precision: '0',inputMode: 'NATURAL', thousands: ',', nullable: 'true' }" class="form-control" formControlName="NewValue" placeholder="Enter {{it.value.Name}}" (keyup)="newValueChange(it.value)" value="{{it.value.NewValue|toNumber|number}}">
                  <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="it.value.Prefix">{{it.value.Prefix}}</span>
                  <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="it.value.Suffix">{{it.value.Suffix}}</span>
                </div>

                <div [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" class="form-group" *ngSwitchCase="it.value.DataType === 'Decimal'">
                  <label class="form-label">
                  </label>
                  <input type="text"
                         inputmode="numeric"
                         mask="separator.2"
                         [dropSpecialCharacters]="false"
                         class="form-control"
                         formControlName="NewValue"
                         placeholder="Enter {{it.value.Name}}"
                         (change)="newValueChange(it.value)" thousandSeparator="," />

                 <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{it.value.Prefix}}</span>
                  <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{it.value.Suffix}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="childFields(i).controls.length >=2">
            <div [ngSwitch]="true">
              <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType==='String'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <input type="text" class="form-control" formControlName="NewValue" placeholder="Enter {{control.value.Name}}">
                <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
                <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
              </div>
              <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Integer'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <input type="text" min="0" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'false', decimal: '.', precision: '0',inputMode: 'NATURAL', thousands: ',', nullable: 'true' }" class="form-control" formControlName="NewValue" placeholder="Enter {{control.value.Name}}" (keyup)="newValueChange(control.value)" value="{{control.value.NewValue|toNumber|number}}">
                <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
                <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
              </div>
              <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Decimal'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <input type="text"
                       min="0"
                       inputmode="numeric"
                       mask="separator.2"
                       [dropSpecialCharacters]="false"
                       class="form-control"
                       formControlName="NewValue"
                       placeholder="Enter {{control.value.Name}}"
                       (keyup)="newValueChange(control.value)" thousandSeparator="," />

                <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="control.value.Prefix">{{control.value.Prefix}}</span>
                <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="control.value.Suffix">{{control.value.Suffix}}</span>
              </div>
              <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="control.value.DataType === 'Boolean'">
                <label class="custom-checkbox margin-right-15" for="{{control.value.Name}}">
                  <input readonly="readonly" formControlName="NewValue" type="checkbox" (change)="autoCalcNewValue($event, control.value)" id="{{control.value.Name}}">
                  <i></i>
                </label>
              </div>
              <div class="form-groupcol-md-3" *ngSwitchCase="control.value.DataType === 'Datetime'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <input bsDatepicker class="form-control" placeholder="mm/dd/yyyy" (ngModelChange)="onNewDateSelection($event, control.value)" type="text" formControlName="NewValue" placement="auto">

                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div class="form-group col-md-3" *ngSwitchCase="control.value.DataType === 'AutoPopulate'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <div class="form-group autocomplete-design">
                  <!--<ng2-completer [textSearching]="TenantName" [maxChars]="90" [datasource]="dataService" class="form-control"
                  formControlName="NewValue" [overrideSuggested]="true" [minSearchLength]="0"></ng2-completer>-->
                  <!--<ng-select [items]="dataService" class="form-control" [searchable]="true" [virtualScroll]="true" [minTermLength]="0"></ng-select>-->
                  <ng-select [items]="dataService$ | async"
                             bindLabel="TenantName"
                             [hideSelected]="true"
                             [loading]="loading"
                              [typeahead]="dataServiceInput$"
                             [minTermLength]="0"
                             (change)="onTenantSelect($event)"
                             formControlName="NewValue">
                  </ng-select>

                </div>
              </div>
              <div class="form-group col-md-3" *ngSwitchCase="control.value.DataType === 'Dropdown'">
                <label class="form-label">
                  {{control.value.Name}}
                </label>
                <label class="select">
                  <select formControlName="NewValue"
                          class="form-control ">
                    <option [value]="null">Select</option>
                    <option *ngFor="let item of control.value.DropDownData.__zone_symbol__value" [(ngValue)]="item.id">{{item.name}}</option>
                  </select>
                  <i></i>
                </label>

              </div>
              <div formArrayName="ChildItems">
                <div [formGroupName]="p" *ngFor="let it of childFields(i).controls; index as p">
                  <div class="form-group  col-md-4" *ngSwitchCase="it.value.DataType === 'Boolean'">
                    <label class="form-label">
                    </label>
                    <label class="custom-checkbox margin-right-15" for="{{it.value.Name}}">
                      <input readonly="readonly" formControlName="NewValue" type="checkbox" (keyup)="autoCalcNewValue($event, it.value)" id="{{it.value.Name}}"> {{it.value.Name}}
                      <i></i>
                    </label>
                  </div>

                  <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="it.value.DataType === 'Integer'">
                    <label class="form-label">
                      &nbsp;
                    </label>
                    <input type="text" min="0" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'false', decimal: '.', precision: '0',inputMode: 'NATURAL', thousands: ',', nullable: 'true' }" class="form-control" formControlName="NewValue" placeholder="Enter {{it.value.Name}}" (keyup)="newValueChange(it.value)" value="{{it.value.NewValue|toNumber|number}}">
                    <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="it.value.Prefix">{{it.value.Prefix}}</span>
                    <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="it.value.Suffix">{{it.value.Suffix}}</span>
                  </div>
                  <div class="form-group col-md-3" [ngClass]="{'textbox-with-btn-left':control.value.Prefix,'textbox-with-btn':control.value.Suffix}" *ngSwitchCase="it.value.DataType === 'Decimal'">
                    <label class="form-label">
                      &nbsp;
                    </label>
                    <input type="text"
                           min="0"
                           inputmode="numeric"
                           mask="separator.2"
                           [dropSpecialCharacters]="false"
                           class="form-control"
                           formControlName="NewValue"
                           placeholder="Enter {{it.value.Name}}"
                           (keyup)="newValueChange(it.value)" thousandSeparator="," />

                    <span _ngcontent-gup-c24="" class="leftlabel" *ngIf="it.value.Prefix">{{it.value.Prefix}}</span>
                    <span _ngcontent-gup-c24="" class="rightlabel" *ngIf="it.value.Suffix">{{it.value.Suffix}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-12 margin-top-15">
        <div class="d-flex align-item-center flex-xl-column">
          <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes" class="file-upload margin-right-5"></file-upload>

        </div>
      </div>


      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="property?.IsPortfolio">
        <div class="floatinghead floatinghead-xs clearfix">
          <div class="clearfix p-1">
            <div class="floatinghead floatinghead-xs clearfix">
              <div class="pull-left"><h2 class="mainhead"><span class="text">Portfolio Properties</span></h2></div>

            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead>
              <tr>
                <th data-orderable="false">
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectAll" (change)="onSelectAll($event.target.checked)" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </th>
                <th class="remove" style="position:static; cursor:default" ng-disabled="true" data-orderable="false"></th>
                <th class="sticky-left" style="width:50px !important">Property Id</th>
                <th class="property-name-column sticky-left">Tenant Name</th>
                <th>OM</th>
                <th>State</th>
                <th>City</th>
                <!--<th [hidden]="hideColumn(4)">Property Type</th>-->
                <th>Status</th>
                <th>Asking Price</th>
                <th>Rent / NOI</th>
                <th>Cap Rate</th>
                <th>Rem. Term</th>
                <th [hidden]="true">Rank</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let prop of portfolioProperties;let i = index">
                <td>
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event.target.checked,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </td>
                <td>
                  <a href="#" routerLink="/viewproperty/{{prop.Guid}}" (click)="onRedirection();">
                    <div class="property-image" *ngIf="prop.FilePath !=null" [ngStyle]="{'background-image': 'url(' + prop.FilePath + ')'}"></div>
                    <div class="property-image" *ngIf="prop.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
                  </a>
                </td>
                <td class="sticky-left" style="width:50px !important">
                  <p>
                    {{ prop.PropertySequenceId }}
                  </p>
                </td>
                <td class="sticky-left">
                  <p>
                    <a href="#" routerLink="/viewproperty/{{prop.Guid}}" (click)="onRedirection();">{{ prop.PropertyName }}</a>
                  </p>
                </td>
                <td>
                  <a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
                    <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
                  </a>
                </td>
                <td><p>{{prop.State ? prop.State : '-'}}</p></td>
                <td><p>{{prop.City ? prop.City : '-'}}</p></td>
                <!--<td [hidden]="hideColumn(4)"><p>{{prop.AssetType ? prop.AssetType : '-'}}</p></td>-->
                <td><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                <td><p class="whitespacenowrap">{{(prop.Price) ? '$ '+ (prop.Price | number:0) : '-'}}</p></td>
                <td><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
                <td *ngIf="!prop.CharacteristicsId"><p>{{ (prop.CapRate) ? (prop.CapRate | number : '1.2-2') + '%' : '-' }}</p></td>
                <td *ngIf="prop.CharacteristicsId"><p>ZCF</p></td>
                <td><p>{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-' }}</p></td>
                <td [hidden]="true"><p>{{ prop.Rank }}</p></td>
              </tr>
            </tbody>
            <tfoot>
              <tr *ngIf="portfolioProperties?.length == 0 ">
                as
                <td colspan="10" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Data Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="clearfix"></div>

      <div class="col-md-12">
        <div class="d-flex">
          <div class="ml-auto d-flex">
            <button type="button" (click)="onClose($event)" class="btn btn-default btn-lg margin-right-10">Cancel</button>
            <button type="submit" class="btn btn-success btn-lg  mr-auto">Save</button>
          </div>

        </div>
      </div>

    </form>

    <div class="form-group docs-list" *ngIf="revisionId > 0">
      <label class="form-label" *ngIf="propertyRevisionModel.Documents && revisionId > 0">Documents</label>
      <ng-container *ngFor="let doc of propertyRevisionModel.Documents; let i= index">
        <p>
          <label>{{i + 1}} </label><a href="{{doc.Url}}" download target="_blank">{{doc.Name}}</a><span (click)="onRemoveDocument(i)" tooltip="Remove" class="remove">
            <i aria-hidden="true" class="icofont icofont-close"></i>
          </span>
        </p>

      </ng-container>
    </div>

  </div>

</div>
